import { CopyTrackingNumber } from './copy-tracking-number';
import { ResendNotifications } from './resend-notifications';
import { SendNotifications } from './send-notifications';
import { UndoMarkShipped } from './undo-mark-shipped';
import { VoidLabel } from './void-label';

export const OtherActions = [ResendNotifications, SendNotifications, UndoMarkShipped, VoidLabel, CopyTrackingNumber];
